import { Eye } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { formatDate } from '../../hooks/useAdminData';

const STATUS_COLORS = {
  new: 'bg-blue-100 text-blue-700',
  reviewed: 'bg-yellow-100 text-yellow-700',
  contacted: 'bg-green-100 text-green-700',
  completed: 'bg-gray-100 text-gray-600',
};

const STATUS_OPTIONS = ['new', 'reviewed', 'contacted', 'completed'];

export const IntakesList = ({ intakes, onSelectIntake, onUpdateStatus }) => (
  <div className="space-y-4" data-testid="admin-intakes-list">
    {intakes.length === 0 ? (
      <Card className="border-none shadow-md">
        <CardContent className="p-8 text-center text-gray-500">No intake submissions found.</CardContent>
      </Card>
    ) : (
      intakes.map((i) => (
        <Card
          key={i.id}
          className="border-none shadow-md hover:shadow-lg transition-all cursor-pointer"
          onClick={() => onSelectIntake(i)}
        >
          <CardContent className="p-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-lg font-bold text-darkBrown">{i.firstName} {i.lastName}</h3>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[i.status] || STATUS_COLORS.new}`}>
                    {i.status}
                  </span>
                </div>
                <p className="text-sm text-gray-600">{i.email} | {i.phone}</p>
                <p className="text-sm text-gray-500 mt-1">DOB: {i.dateOfBirth} | Insurance: {i.insuranceProvider || 'Self-pay'}</p>
                <p className="text-gray-700 mt-2 line-clamp-1"><strong>Reason:</strong> {i.reasonForVisit}</p>
                <p className="text-xs text-gray-400 mt-2">{formatDate(i.timestamp)}</p>
              </div>
              <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
                <Button variant="outline" size="sm" onClick={() => onSelectIntake(i)} className="border-primaryOrange text-primaryOrange">
                  <Eye size={14} className="mr-1" /> View
                </Button>
                <select
                  value={i.status}
                  onChange={(e) => onUpdateStatus('intake', i.id, e.target.value)}
                  className="text-sm border rounded-md px-3 py-1.5"
                >
                  {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
);
